// frontend/src/services/apiPresupuestos.js
import axios from 'axios';
import api from './api';

// Obtener la URL base correcta sin /content/
// Si api.baseURL es "http://localhost:8000/api/content"
// Queremos "http://localhost:8000/api/"
const BASE = (api?.defaults?.baseURL || '').replace(/\/+$/, ''); // sin slash final
// Simplemente reemplazar /content con nada
const API_ROOT = BASE.replace(/\/content$/i, '');

console.log('🔧 apiPresupuestos - BASE URL:', BASE);
console.log('🔧 apiPresupuestos - API_ROOT:', API_ROOT);
console.log('🔧 apiPresupuestos - Final baseURL:', `${API_ROOT}/`);

// Crear cliente para presupuestos en /api (sin /content)
const apiPresupuestos = axios.create({
  baseURL: `${API_ROOT}/`,  // ej: https://agencia.geves.cl/api/
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Interceptor para loguear solicitudes
apiPresupuestos.interceptors.request.use((config) => {
  const fullURL = `${config.baseURL || ''}${config.url}`;
  console.log(`📡 apiPresupuestos ${config.method.toUpperCase()}: ${fullURL}`);
  return config;
});

// Interceptor para errores
apiPresupuestos.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      console.log('No autenticado - redirigir a login');
    }
    console.error('❌ apiPresupuestos error:', error.response?.status, error.response?.data || error.message);
    return Promise.reject(error);
  }
);

// Obtener CSRF token
function getCookie(name) {
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookie = cookies[i].trim();
      if (cookie.substring(0, name.length + 1) === (name + '=')) {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }
  return cookieValue;
}

// Añadir CSRF token a peticiones POST/PUT/DELETE
apiPresupuestos.interceptors.request.use((config) => {
  if (['post', 'put', 'patch', 'delete'].includes(config.method)) {
    config.headers['X-CSRFToken'] = getCookie('csrftoken');
  }
  return config;
});

// Interceptor para añadir token de autenticación
apiPresupuestos.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) {
    config.headers['Authorization'] = `Bearer ${token}`;
  }
  return config;
});

export default apiPresupuestos;
